"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BasisTheoryPermissions", {
  enumerable: true,
  get: function () {
    return _BasisTheoryPermissions.BasisTheoryPermissions;
  }
});

var _BasisTheoryPermissions = require("./BasisTheoryPermissions");